import { render, staticRenderFns } from "./EfficiencyTestsDefinition.vue?vue&type=template&id=1fcca21e&scoped=true"
import script from "./EfficiencyTestsDefinition.vue?vue&type=script&lang=js"
export * from "./EfficiencyTestsDefinition.vue?vue&type=script&lang=js"
import style0 from "./EfficiencyTestsDefinition.vue?vue&type=style&index=0&id=1fcca21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcca21e",
  null
  
)

export default component.exports